/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeV2HazardBoxData } from './moe-v2-hazard-box.data';
import { IMoeV2HazardBoxProps } from './moe-v2-hazard-box.props.autogenerated';

export interface IMoeV2HazardBoxViewProps extends IMoeV2HazardBoxProps<IMoeV2HazardBoxData> {}

/**
 *
 * MoeV2HazardBox component
 * @extends {React.PureComponent<IMoeV2HazardBoxProps<IMoeV2HazardBoxData>>}
 */
class MoeV2HazardBox extends React.PureComponent<IMoeV2HazardBoxProps<IMoeV2HazardBoxData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeV2HazardBox;
